import { Booking } from './models';
import {
  buildHaystack,
  matchesSearchTerm,
  MatchMode,
  normalize,
} from './search-utils';

export function dashboardQuicksearch(
  bookings: Booking[],
  term: string,
  mode: MatchMode = 'or',
): Booking[] {
  const query = normalize(term);
  if (!query) return [...bookings];

  return bookings.filter((b) =>
    matchesSearchTerm(buildHaystack(b), term, mode),
  );
}
